export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/currentAffairs.3bad7fa8.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};